const localeInPathRegExp = /^\/([a-z]{2}-[A-Z]{2})(\/.*)/;

/**
 * @param {string} url - The URL to parse.
 * @description Parses a localized URL to extract the locale and path.
 * The URL should be in the format "/{locale}/{path}" where locale is a two-letter language code
 * and path is the remaining part of the URL.
 * @return {({ locale: string; path: string } | undefined)}
 *
 * @example
 * // Input: "/en-US/some/path"
 * // Output: { locale: "en-US", path: "/some/path" }
 */
export default (url) => {
  const pathnameLangMatches = url.match(localeInPathRegExp);
  if (pathnameLangMatches && pathnameLangMatches.length === 3) {
    return {
      locale: pathnameLangMatches[1],
      path: pathnameLangMatches[2],
    };
  }
  return undefined;
};
